// 18 seconds: steady rotation, then a visible five-second deceleration.
const SPIN_DURATION=18000;
function wheelProgress(t){
 t=Math.min(1,Math.max(0,t));const ramp=.08,coast=.72,tail=.28;
 const area=ramp/2+(coast-ramp)+tail/3;
 if(t<ramp)return t*t/(2*ramp*area);
 if(t<coast)return (ramp/2+t-ramp)/area;
 const u=(t-coast)/tail;
 return (ramp/2+coast-ramp+tail/3*(1-Math.pow(1-u,3)))/area;
}
function wheelTarget(slot,count){return 10*360+360-(slot+.5)*360/count;}
module.exports={SPIN_DURATION,wheelProgress,wheelTarget};
